export const error: any = {
  expiredTitle: "ページの有効期限が切れました",
  errorMessageTitle: "エラーが発生しました",
  hotelNotFoundTitle: "ホテルが見つかりませんでした",
  hotelNotFoundDescription:
    "検索条件に該当するホテルはありません。他の検索条件で最初からもう一度検索してください。",
};
